module.exports = __webpack_public_path__ + "assets/9b597f50d12c26b8570da4a18543fc02.wav";